import type {ReactElement} from 'react'
import type {PanelStyleT} from './style'
import {getCardHeaderClass} from './style'
import {panelHeader, panel} from './student-group-panel.module.scss'

type Props = {
  panelStyle: PanelStyleT
  panelClass?: string
  header: ReactElement
  children: ReactElement
}

export const StudentGroupPanel = ({panelStyle, panelClass, header, children}: Props) => (
  <div className={panelClass === undefined ? panel : `${panelClass} ${panel}`}>
    <div className={`text-center ${panelHeader} ${getCardHeaderClass(panelStyle)}`}>{header}</div>
    <div className="student-group-panel-body">{children}</div>
  </div>
)
